import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import GrayDownArrow from '../../assets/images/pills/arrows/grayDownArrow';
import GrayUpArrow from '../../assets/images/pills/arrows/grayUpArrow';
import WhiteDownArrow from '../../assets/images/pills/arrows/whiteDownArrow';
import propertiesText from '../../assets/properties.json';
interface IElement {
  target: any;
}

interface ISelect {
  items?: string[];
  onChangeSelect?: (value: string) => void;
  defaultValue?: string;
  value?: string;
  dropdownLabel?: string;
  customClassName?: string;
  customBackground?: string;
  customBackgroundEmpty?: string;
  containerOptionsClassName?: string;
}

/**
 * Componente de select personalizado con dropdown.
 * Permite seleccionar un valor de una lista de opciones.
 * @param customBackground - Color de fondo cuando hay un valor seleccionado (por defecto: '#7B61FF')
 * @param customBackgroundEmpty - Color de fondo cuando no hay valor seleccionado (por defecto: '#CCCCCC')
 * @param containerOptionsClassName - Clase para el contenedor de las opciones (por defecto: '')
 */
const CustomSelect: FC<ISelect> = ({
  items,
  defaultValue,
  onChangeSelect,
  value,
  dropdownLabel,
  customClassName = '',
  customBackground,
  customBackgroundEmpty,
  containerOptionsClassName = ''
}) => {
  const [openList, setOpenList] = useState<boolean>(false);

  const textJSON: any = propertiesText;
  const refContainer = useRef<HTMLDivElement>(null);

  const onHandleClickAway = useCallback(
    async (e: IElement) => {
      if (refContainer.current && !refContainer.current.contains(e.target)) setOpenList(false);
    },
    [refContainer]
  );

  const asignArrow = () => {
    if (value && !openList) return <WhiteDownArrow />;
    if (value && openList) return <WhiteDownArrow style={{ transform: 'rotate(180deg)' }} />;
    if (!value && !openList) return <GrayDownArrow />;
    if (!value && openList) return <GrayUpArrow />;
  };

  const generateOptions = () => {
    if (!items) return;
    return items.map(item => {
      const itemIsSelected = value === item;
      return (
        <div
          key={uuid()}
          className={`item ${itemIsSelected ? 'itemIsSelected' : ''}`}
          onClick={() => {
            onChangeSelect?.(item);
            setOpenList(false);
          }}
        >
          {changeText(item)}
        </div>
      );
    });
  };

  const changeText = (text: string) => {
    const searchText = textJSON[text] || text;
    return searchText;
  };

  useEffect(() => {
    window.addEventListener('mousedown', onHandleClickAway);
    return () => {
      window.removeEventListener('mousedown', onHandleClickAway);
    };
  }, [onHandleClickAway]);

  const backgroundColor = value ? customBackground || '#7B61FF' : customBackgroundEmpty || '#CCCCCC';

  return (
    <div
      ref={refContainer}
      id="customSelect"
      style={{ background: backgroundColor, borderRadius: openList ? '6px 6px 0px 0px' : '' }}
      onClick={() => {
        if (items && !!items?.length) setOpenList(!openList);
      }}
      className={`customSelect ${openList ? 'openListStyles' : ''} ${customClassName}`}
    >
      <div className="selectOption">
        <div className="defaultValue">
          {value ? <div className="blackText">{changeText(value)}</div> : <div className="text">{defaultValue}</div>}
        </div>
      </div>
      <div className="arrow">
        <div className="m-auto block">{asignArrow()}</div>
      </div>
      {openList && items && !!items.length && (
        <div className={`containerOptions ${containerOptionsClassName}`}>
          {dropdownLabel && <div className="dropdownLabel">{dropdownLabel}</div>}
          {generateOptions()}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
